import React from 'react';
import {
  linkToAppStore,
  linkToGooglePlay,
  linkToFb,
  lintToFbDk,
  linkToYoutube,
} from 'app/constants/links';

import { Button } from 'antd';

import { FacebookOutlined, YoutubeOutlined } from '@ant-design/icons';

import withTranslations from 'app/components/HOGs/withTranslations';
import { AppStoreIcon, GooglePlayIcon } from '../svg';

const SocialBtn = (props) => {
  const { collapse, tr } = props;

  const openLinkToAppInNewTab = (url) => {
    const win = window.open(url, '_blank');
    win.focus();
  };

  return collapse ? (
    <div className="social-btns_small">
      <Button
        className="app-btn_small app_store"
        onClick={() => openLinkToAppInNewTab(linkToAppStore)}
      >
        <AppStoreIcon />
      </Button>
      <Button
        className="app-btn_small google_play"
        onClick={() => openLinkToAppInNewTab(linkToGooglePlay)}
      >
        <GooglePlayIcon />
      </Button>
      <Button
        className="app-btn_small facebook"
        onClick={() => {
          openLinkToAppInNewTab(lintToFbDk);
        }}
      >
        <FacebookOutlined style={{ color: '#333333' }} />
      </Button>
      <Button
        className="app-btn_small facebook"
        onClick={() => {
          openLinkToAppInNewTab(linkToFb);
        }}
      >
        <FacebookOutlined style={{ color: '#333333' }} />
      </Button>
      <Button
        className="app-btn_small facebook"
        onClick={() => {
          openLinkToAppInNewTab(linkToYoutube);
        }}
      >
        <YoutubeOutlined style={{ color: '#333333' }} />
      </Button>
    </div>
  ) : (
    <div className="flex social-btns">
      <div>
        <Button
          className="app-btn app_store"
          size="small"
          onClick={() => openLinkToAppInNewTab(linkToAppStore)}
        >
          <AppStoreIcon />
          <p>{tr['App Store']}</p>
        </Button>
        <Button
          className="app-btn google_play "
          size="small"
          to="#"
          onClick={() => openLinkToAppInNewTab(linkToGooglePlay)}
        >
          <GooglePlayIcon />
          <p>{tr['Google Play']}</p>
        </Button>
      </div>
      <div>
        <Button
          className="app-btn facebook "
          size="small"
          onClick={() => {
            openLinkToAppInNewTab(lintToFbDk);
          }}
        >
          <FacebookOutlined style={{ color: '#333333' }} />
          <p>{tr.DK}</p>
        </Button>
        <Button
          className="app-btn facebook "
          size="small"
          onClick={() => {
            openLinkToAppInNewTab(linkToFb);
          }}
        >
          <FacebookOutlined style={{ color: '#333333' }} />
          <p>{tr.ENGLISH}</p>
        </Button>
      </div>
      <div>
        <Button
          className="app-btn facebook "
          size="small"
          onClick={() => {
            openLinkToAppInNewTab(linkToYoutube);
          }}
        >
          <YoutubeOutlined style={{ color: '#333333' }} />
          <p>Youtube</p>
        </Button>
      </div>
    </div>
  );
};

export default withTranslations(SocialBtn);
